import { z } from 'zod';

export const ProfileSummarySchema = z.object({
  exists: z.boolean(),
  customer_id: z.string().nullable(),
  display_name: z.string().nullable(),
  email: z.string().nullable(),
  kyc_status: z.enum(['pending','approved','rejected','resubmit','unknown']).nullable().or(z.string().nullable()),
  tos_status: z.enum(['accepted','required','unknown']).nullable().or(z.string().nullable()),
});

export type ProfileSummaryInfer = z.infer<typeof ProfileSummarySchema>;